import { z } from 'zod';
import { MINIMUM_CAR_REGISTRATION_YEAR } from '@/api/entities/vehicule';
import i18next from 'i18next';
import {
  FRENCH_LICENSE_PLATE_NUMBER_REGEX,
  VIN_REGEX,
} from '@/utils/regex.utils';

export const vehiculeSchema = z
  .object({
    id: z.string().optional(),
    brand: z.string().superRefine((data, ctx) => {
      if (!data) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: i18next.t('vehicule:theBrandIsRequired'),
        });
      }
    }),
    model: z.string().superRefine((data, ctx) => {
      if (!data) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: i18next.t('vehicule:theModelIsRequired'),
        });
      }
    }),
    vin: z
      .string()
      .nullish()
      .superRefine((data, ctx) => {
        if (data && !VIN_REGEX.test(data)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: i18next.t('common:vinIncorrect'),
          });
        }
      }),
    licensePlateNumber: z
      .string()
      .nullish()
      .superRefine((data, ctx) => {
        if (data && !FRENCH_LICENSE_PLATE_NUMBER_REGEX.test(data)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: i18next.t('common:licensePlateNumberFrenchIncorrect'),
          });
        }
      }),
    // yearOfFirstRegistration: z
    //   .string()
    //   .transform((val) => parseInt(val, 10))
    //   .nullish(),
    // mileage: z
    //   .string()
    //   .transform((val) => parseInt(val, 10))
    //   .nullish(),
    yearOfFirstRegistration: z
      .union([z.string(), z.number()])
      .transform((val) => parseInt(val as string, 10))
      .nullish(),
    mileage: z
      .union([z.string(), z.number()])
      .transform((val) => parseInt(val as string, 10))
      .nullish(),
    requestVehiculeCheck: z.boolean().default(false),
    picture: z.string().nullish(),
    ownerType: z.string().nullish(),
    ownerGroupId: z.string().nullish(),
    ownerCompanyId: z.string().nullish(),
    comment: z.string().nullish(),
    isOutsideFleet: z.boolean().default(false),
    active: z.boolean().default(true),
  })
  .superRefine((data, ctx) => {
    if (
      data.yearOfFirstRegistration &&
      data.yearOfFirstRegistration < MINIMUM_CAR_REGISTRATION_YEAR
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['yearOfFirstRegistration'],
        message: i18next.t('vehicule:pleaseEnterValidYearOfRegistration'),
      });
    }

    if (data.yearOfFirstRegistration > Number(new Date().getFullYear())) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['yearOfFirstRegistration'],
        message: i18next.t(
          'vehicule:pleaseEnterAYearLessThanOrEqualToThisYear'
        ),
      });
    }

    if (data.mileage && data.mileage < 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['mileage'],
        message: i18next.t('vehicule:pleaseEnterValidMileage'),
      });
    }
  });

export type TVehiculeSchema = z.infer<typeof vehiculeSchema>;
